import { RoleHeadCellData } from "@domain/Interfaces/HeadCellData.d";
import { RoleHeadCell } from "@domain/Interfaces/HeadCell.d";
import Order from "@domain/Interfaces/Order.d";
import { TableHead, TableRow, TableCell, TableSortLabel, useTheme } from "@mui/material";
import { StyledArrowSortIcon, StyledArrowUpIcon, StyledArrowDownIcon } from "@presentation/components/TotalFilterIcon";
import { useTranslation } from "react-i18next";

type RolesTableProps = {
  onRequestSort: (event: React.MouseEvent<unknown>, property: keyof RoleHeadCellData) => void;
  order: Order;
  orderBy: string;
  headCells: RoleHeadCell[];
};

const TotalTableHead = ({ order, orderBy, onRequestSort, headCells }: RolesTableProps): JSX.Element => {
  const theme = useTheme();
  const createSortHandler = (property: keyof RoleHeadCellData) => (event: React.MouseEvent<unknown>) => {
    onRequestSort(event, property);
  };

  const { t } = useTranslation();

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell: RoleHeadCell) => {
          let iconComponent = StyledArrowSortIcon;
          if (orderBy === headCell.id && order === "asc") {
            iconComponent = StyledArrowUpIcon;
          } else if (orderBy === headCell.id) {
            iconComponent = StyledArrowDownIcon;
          }
          return (
            <TableCell
              key={headCell.id}
              align="left"
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              {headCell.enableSorting ? (
                <TableSortLabel
                  active
                  sx={{ color: orderBy === headCell.id ? theme.palette.secondary.main : "inherit" }}
                  IconComponent={iconComponent}
                  onClick={headCell.enableSorting ? createSortHandler(headCell.id) : () => undefined}
                >
                  {headCell.label}
                </TableSortLabel>
              ) : (
                headCell.label
              )}
            </TableCell>
          );
        })}
        <TableCell align="right">{t("datasets_roles.headers.actions")}</TableCell>
      </TableRow>
    </TableHead>
  );
};

export default TotalTableHead;
